import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CaptionSource } from '@osmosis/shared/types/learn';

import { P } from '@osmosis/tailwind-ui/components/Text';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { bg300 } from '@osmosis/tailwind-ui/styles/background';
import { languageIntlStrings } from '../../constants/formatMesage';

export type CaptionSelectProps = {
  captions?: CaptionSource[];
  activeCaptions?: CaptionSource;
  setActiveCaptions: (caption: CaptionSource | undefined) => void;
};

const hoverClasses = `dark:hover:bg-slate-600 hover:slate-300`;

/**
 * .
 */
export default function CaptionSelect({
  captions,
  activeCaptions,
  setActiveCaptions,
}: CaptionSelectProps): JSX.Element {
  const intl = useIntl();
  return (
    <Flex cn="flex-col p-2">
      {captions?.map((caption) => (
        <Button
          key={caption.srcLang}
          variant="transparent"
          cn={`p-2 ${hoverClasses} cursor-pointer rounded-lg ${
            caption.srcLang === activeCaptions?.srcLang ? bg300 : 'bg-[inherit]'
          }`}
          onClick={() => setActiveCaptions(caption)}
          data-testid={`captions-${caption.srcLang}`}
        >
          {intl.formatMessage(languageIntlStrings[caption.srcLang || 'en'])}
        </Button>
      ))}
      <Button
        variant="transparent"
        cn={`p-2 cursor-pointer ${hoverClasses}`}
        onClick={() => setActiveCaptions(undefined)}
        data-testid="captions-off"
      >
        <P>
          <FormattedMessage defaultMessage="Off" id="video.captions.off" />
        </P>
      </Button>
    </Flex>
  );
}
